import { useEffect } from "react";
import _ from "lodash";
import store from "../../store";

export const useManualSetLoading = (value: unknown) => {
  useEffect(() => {
    store.dispatch({
      type: `APPEARANCE:SET_UPLOAD_ATTACHMENTS_LOADING`,
      payload: {
        value,
      },
    });
    return () => {
        store.dispatch({
          type: `APPEARANCE:SET_UPLOAD_ATTACHMENTS_LOADING`,
          payload: {},
        });
      
    };
  }, [value]);
};
